import * as React from 'react';
import { createSelector, Selector } from 'reselect';

import { SpacesSiteUrls } from '../spaces/SpacesSiteUrls';
import { AppState } from '../state/AppState';
import { MapStateToProps } from '../utils/ConnectUtils';
import { selectSessionSite } from './SessionInfoSelectors';

export interface SiteUrlsProps {
  urls: SpacesSiteUrls;
}

// This "selector" ignores the redux state and returns the query string portion of the URL.
// Note that it returns the "real" query string, not the one in the hash/fragment.
// This selector exists so that it can be given as an input to createSelector,
// so that memoization works correctly.
// In normal usage, the query string never changes after the initial page load,
// so it doesn't matter that the query string updates aren't concurrent with Redux updates.
export const queryStringSelector = () => window.location.search;

export const siteUrlsSelector: Selector<AppState, SpacesSiteUrls> = createSelector(
  selectSessionSite,
  queryStringSelector,
  // Some code, including populateContentBreadcrumbs, expect SpacesSiteUrls to be falsy
  // when there's no session (and hence no session site).  This preserves that behavior.
  (site, queryString) => site ? new SpacesSiteUrls({ siteUrlName: site.urlName, queryString }) : null
);

export const mapStateToSiteUrlsProps: MapStateToProps<SiteUrlsProps> =
  (state: AppState): SiteUrlsProps => ({
    urls: siteUrlsSelector(state)
  });
